import React, { useState } from 'react';
import { FiPercent, FiPlus, FiTrash2 } from 'react-icons/fi';

const PromoCodes = () => {
    const [coupons, setCoupons] = useState([
        { id: 1, code: 'EARLYBIRD20', discountType: 'PERCENTAGE', discountValue: 20, maxUses: 100, usedCount: 34, status: 'ACTIVE' },
        { id: 2, code: 'TAPCOE100', discountType: 'FLAT', discountValue: 100, maxUses: 50, usedCount: 12, status: 'ACTIVE' },
    ]);

    return (
        <div className="max-w-5xl mx-auto space-y-6 text-left pb-20">
            <div className="flex items-center justify-between bg-white border border-slate-200 p-6 rounded-2xl shadow-sm">
                <div>
                    <h1 className="text-2xl font-black text-slate-900 tracking-tight flex items-center gap-2">
                        <FiPercent className="text-purple-700" /> Promo Codes & Discounts
                    </h1>
                    <p className="text-xs font-medium text-slate-500 mt-1">Create promotional coupons for tickets and registration discounts</p>
                </div>
                <button
                    onClick={() => alert('Create coupon modal')}
                    className="px-4 py-2.5 rounded-xl bg-purple-700 hover:bg-purple-800 text-white text-xs font-bold transition-all flex items-center gap-2 shadow-sm"
                >
                    <FiPlus className="w-4 h-4" /> Create Promo Code
                </button>
            </div>

            <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
                <table className="w-full text-left text-xs text-slate-700">
                    <thead className="bg-slate-100/70 text-slate-600 font-extrabold uppercase tracking-wider text-[11px] border-b border-slate-200">
                        <tr>
                            <th className="p-4">Coupon Code</th>
                            <th className="p-4">Discount</th>
                            <th className="p-4">Redemptions</th>
                            <th className="p-4">Status</th>
                            <th className="p-4 text-right">Action</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 bg-white">
                        {coupons.map((c) => (
                            <tr key={c.id} className="hover:bg-slate-50 transition-colors">
                                <td className="p-4 font-mono font-bold text-purple-900 text-sm">{c.code}</td>
                                <td className="p-4 font-bold text-emerald-700">
                                    {c.discountType === 'PERCENTAGE' ? `${c.discountValue}% OFF` : `₹${c.discountValue} FLAT OFF`}
                                </td>
                                <td className="p-4 text-slate-600 font-medium">{c.usedCount} / {c.maxUses}</td>
                                <td className="p-4">
                                    <span className="px-2.5 py-1 rounded text-[10px] font-extrabold bg-emerald-50 text-emerald-800 border border-emerald-200">
                                        {c.status}
                                    </span>
                                </td>
                                <td className="p-4 text-right">
                                    <button onClick={() => setCoupons(prev => prev.filter(x => x.id !== c.id))} className="text-rose-600 hover:text-rose-700 p-1">
                                        <FiTrash2 className="w-4 h-4" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PromoCodes;
